import { MLNodeData } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";

export const extractMLNodeFields = (
  data: MLNodeData,
  nodeId: string,
): SearchableField[] => {
  return [
    {
      id: `${nodeId}:src`,
      value: data.src,
    },
  ];
};
